import Model from 'flarum/common/Model';

export default class MeritTransaction extends Model {
    amount = Model.attribute<number>('amount');
    type = Model.attribute<string>('type');
    reason = Model.attribute<string>('reason');
    createdAt = Model.attribute<string>('createdAt');

    sender = Model.hasOne('sender');
    receiver = Model.hasOne('receiver');
    post = Model.hasOne('post');
}
